/**
 * engagementreducer.js
 * Created by calhosh on 8/27/2020.
 */

import initialState from '../initialstate';
import * as types from '../../actions/actiontypes';
import _ from 'lodash';
import {currentResource} from '../../util/utils';

export function engagementReducer(state = initialState.engagement, action) {
	switch (action.type) {
		case types.GET_ENGAGEMENT: {
			if (action.response && !action.error) {
				return action.response;
			} else {
				return state;
			}
		}
		case types.UPDATE_ENGAGEMENT: {
			if (action.response && !action.error) {
				return action.response;
			} else {
				return state;
			}
		}
		default:
			return state;
	}
}

export function engagementTeamMembers(state = initialState.engagementTeamMembers, action) {
	switch (action.type) {
		case types.GET_ENGAGEMENT_TEAM_MEMBERS: {
			if (action.response && action.response.users && action.response.users.length > 0) {
				let users = action.response.users.map((user) => {
					return {
						value: user.userId,
						label: user.firstName + ' ' + user.lastName,
						emailAddress: user.emailAddress
					};
				});

				// Sort by user name
				if (action.sortByName) {
					users = users.sort((a, b) => (a.label.toUpperCase() > b.label.toUpperCase() ? 1 : -1));
				}

				return users;
			}
			return state;
		}
		default:
			return state;
	}
}

export function engagementMetaDataReducer(state = initialState.engagementMetaData, action) {
	switch (action.type) {
		case types.LOAD_ENGAGEMENTMETADATA:
			return action.response || state;
		default:
			return state;
	}
}

export function engagementUsersWithRoles(state = initialState.engagementUsersWithRoles, action) {
	switch (action.type) {
		case types.GET_ENGAGEMENT_USERS_WITHROLES: {
			return action.response;
		}
		default:
			return state;
	}
}

export function countryStatusReducer(state = initialState.countryStatus, action) {
	switch (action.type) {
		case types.GET_COUNTRY_STATUS: {
			return action.response;
		}
		default:
			return state;
	}
}

export function engagementUserRolesReducer(state = initialState.roles, action) {
	switch (action.type) {
		case types.GET_ALL_ENGAGEMENT_USER_ROLES:
			return getLocalizedRoles(action);
		default:
			return state;
	}
}

export function rbacUserRolesReducer(state = initialState.rbacRoles, action) {
	switch (action.type) {
		case types.GET_ALL_RBAC_USER_ROLES:
			return action.response;
		default:
			return state;
	}
}

export function getLanguagesReducer(state = initialState.languages, action) {
	switch (action.type) {
		case types.GET_LANGUAGES:
			return action.response;
		default:
			return state;
	}
}

export function formatLanguagesForDropdown(languages) {
	if (languages && languages.length > 0) {
		return languages.map((item) => {
			return {
				value: item.languageId,
				label: item.languageName,
				title: item.languageName,
				pcaobReferenceLanguageId: item.pcaobReferenceLanguageId

			};
		});
	}
}

export function getCountriesReducer(state = initialState.countries, action) {
	switch (action.type) {
		case types.GET_COUNTRIES:
			return action.response;
		default:
			return state;
	}
}

export function formatCountriesForDropdown(countries) {
	if (countries && countries.length > 0) {
		return countries.map((item) => {
			return {
				value: item.cgCountryID,
				label: item.countryName,
				title: item.countryName
			};
		});
	}
}

function getLocalizedRoles(action) {
	let engagementUserRoles = [];

	let localizedEngagementUserRoles = currentResource.roleForMember;
	_.each(action.response, function(apiRole) {
		let localRole = localizedEngagementUserRoles.find((x) => x.id === apiRole.id);
		let finalName = localRole ? localRole.role : apiRole.name;
		engagementUserRoles.push({
			id: apiRole.id,
			name: finalName
		});
	});

	return engagementUserRoles;
}

export function workspaceReducer(state = initialState.workspaceMetaData, action) {
	switch (action.type) {
		case types.GET_WORKSPACE_METADATA: {
			return action.response;
		}
		default:
			return state;
	}
}

/**
 * This reducer function handles all the actions related to paans user user object.
 * @param {Object} state - A portion of the overall state which represents the user currently in memory.
 * @param {Object} action - Action object containing type and other values
 * @return {Object} - the currently paans policy accepted user
 */
export function paansReducer(state = initialState.paansUserData, action) {
	switch (action.type) {
		case types.CHECK_USER_ACCEPTED_PAANS_POLICY:
			return action.response || initialState.paansUserData;
		default:
			return state;
	}
}

export function setEngagementIdReducer(state = initialState.engagementId, action) {
	switch (action.type) {
		case types.SET_ENGAGEMENT_ID: {
			return action.engagementId;
		}
		default:
			return state;
	}
}

export function setIsAresViewReducer(state = initialState.isAresView, action) {
	switch (action.type) {
		case types.SET_IS_ARESVIEW: {
			return action.isAresView;
		}
		default:
			return state;
	}
}

export function setServerPrintDataReducer(state = initialState.serverPrintData, action) {
	switch (action.type) {
		case types.SET_SERVER_PRINT_DATA: {
			return action.serverPrintData;
		}
		default:
			return state;
	}
}

export function setIsDrawerModeReducer(state = initialState.isDrawerMode, action) {
	switch (action.type) {
		case types.SET_IS_DRAWER_MODE: {
			return action.isDrawer;
		}
		default:
			return state;
	}
}

export function setIsTrackChangesViewReducer(state = initialState.isTrackChangesView, action) {
	switch (action.type) {
		case types.SET_IS_TRACK_CHANGES_VIEW: {
			return action.isTrackChangesView;
		}
		default:
			return state;
	}
}

export function setIsCompareResponsesViewReducer(state = initialState.isCompareResponsesView, action) {
	switch (action.type) {
		case types.SET_IS_COMPARE_RESPONSES_VIEW: {
			return action.isCompareResponsesView;
		}
		default:
			return state;
	}
}

export function setIsGuidedWorkFlowV2Reducer(state = initialState.isGuidedWorkFlowV2, action) {
	switch (action.type) {
		case types.SET_IS_GUIDEDWORKFLOWV2: {
			return action.isGuidedWorkFlowV2;
		}
		default:
			return state;
	}
}

export function setHasBodyIdFilterReducer(state = initialState.hasBodyIdFilter, action) {
	switch (action.type) {
		case types.SET_HAS_BODY_ID_FILTER: {
			return action.hasBodyIdFilter;
		}
		default:
			return state;
	}
}

export function setNavigationFilterReducer(state = initialState.navigationFilter, action) {
	switch (action.type) {
		case types.SET_NAVIGATION_FILTER: {
			return action.navigationFilter;
		}
		default:
			return state;
	}
}
